import React, { ReactElement } from 'react';

import { ReactComponent as ArrowSingle } from '../../../resources/icons/arrow-single.svg';
import { ReactComponent as ArrowDouble } from '../../../resources/icons/arrow-double.svg';

import './pagination.scss';

type Props = {
  pageCount: number;
  currentPage: number;
  setCurrentPage: (number: number) => void;
};

const Pagination = ({ pageCount, currentPage, setCurrentPage }: Props): ReactElement => {
  const incrementPage = (): void => {
    if (currentPage < pageCount - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const decrementPage = (): void => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToFirstPage = (): void => {
    setCurrentPage(0);
  };

  const goToLastPage = (): void => {
    setCurrentPage(pageCount - 1);
  };

  return (
    <div className="pagination">
      <div className="pagination__button" onClick={goToFirstPage} data-testid="first-page-button">
        <ArrowDouble fill="white" />
      </div>
      <div className="pagination__button" onClick={decrementPage} data-testid="decrement-page-button">
        <ArrowSingle fill="white" />
      </div>
      {pageCount > 0 && <div className="pagination__page-number">{`${currentPage + 1} of ${pageCount}`}</div>}
      {pageCount < 1 && <div className="pagination__page-number">0 of 0</div>}
      <div className="pagination__button" onClick={incrementPage} data-testid="increment-page-button">
        <ArrowSingle fill="white" />
      </div>
      <div className="pagination__button" onClick={goToLastPage} data-testid="last-page-button">
        <ArrowDouble fill="white" />
      </div>
    </div>
  );
};

export default Pagination;
